import React from 'react';

function LandingPage() {
  return <div>Tela inicial aqui</div>;
}

export default LandingPage;
